/**
 * スクロール時、トリガーが起動した際にクラス名を付与する関数
 * 
 * @param element HTML要素 複数要素は禁止
 * @param position 画面に対してのパーセンテージ（50％であれば要素TOPが画面中央に来た時にトリガーが起動する）
 * @returns scrollY スクロール量
 */
export const scrollTrigger = ( element, position = 0 ) => {

  const header  = document.querySelector( '.l-header' );
  const windowH = window.innerHeight;
  let elementOffsetTop;
  if ( window.matchMedia( "(max-width: 1059px)" ).matches ) {
    elementOffsetTop = element.getBoundingClientRect().top - header.offsetHeight;
  } else {
    elementOffsetTop = element.getBoundingClientRect().top;
  }
  let scrollY, triggerPoint;

  addEventListener( 'scroll', function () {
    scrollY = this.scrollY;

    if ( position === 0 ) {
      triggerPoint = elementOffsetTop;
    } else {
      triggerPoint = elementOffsetTop - ( windowH * ( position * 0.01 ) );
    }

    if ( scrollY > triggerPoint ) {
      element.classList.add( 'is--scrollTrigger' );
    } else {
      element.classList.remove( 'is--scrollTrigger' );
    }

    return scrollY;
  }, {passive: true} );
}
